import { RequestDraftStatus } from '@prisma/client';

import { TrpcOutputs } from '../../config/trpc';

export type Draft = TrpcOutputs['getRequestDraft'];

export const statusColor: Record<RequestDraftStatus, string> = {
  Pending: 'blue',
  Approved: 'green',
  Discarded: 'gray',
};

/** What each status is called on screen: `Approved` is stored, but what happened is that it was applied. */
export const statusLabel: Record<RequestDraftStatus, string> = {
  Pending: 'Pending',
  Approved: 'Applied',
  Discarded: 'Discarded',
};
